import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltApiResponseService {

  constructor(private http: HttpClient) { }

  /**
   * Get SLT Response Data from the API
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param type Type of response (e.g., 'STATE_API_RESPONSE')
   * @param logId Log ID from rowData
   * @returns Observable with response data
   */
  getSltResponseData(baseUrl: string, type: string, logId: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32710&input=${type}&log_id=${logId}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }

  /**
   * Get ME Codes List for the given tax year
   * @param baseUrl Base URL from GENERAL_CONFIG
   * @param taxYear Tax year from rowData
   * @returns Observable with ME codes list
   */
  getMeCodesList(baseUrl: string, taxYear: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32736&tax_year=${taxYear}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }
}
